<template>
  <div>
    <b-row>
      <b-col cols="md-6 12">
        <b-form-group
          label="CPF ou CNPJ do Proprietário do Veículo *"
          label-size="sm"
          label-class="font-weight-bold"
          invalid-feedback="Selecione um CPF ou CNPJ"
        >
          <b-form-select
            v-model="$v.filtro.cpf_cnpj_proprietario.$model"
            :state="validarCampo('cpf_cnpj_proprietario')"
            :options="listaCpfCnpj"
            size="sm"
            autocomplete="off"
            @keydown.native="keydownPesquisa"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="md-6 12">
        <b-form-group label-size="sm">
          <template slot="label"
            ><span style="font-weight: bold" v-if="!buscaAvancada"
              >Período da Infração *&nbsp;</span
            ><span v-else>Período da Infração&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="Campo obrigatório quando não houver campos preenchidos na busca avançada"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon>
          </template>
          <b-input-group size="sm">
            <b-input
              type="date"
              max="3000-12-31"
              v-model="$v.filtro.data_infracao_inicio.$model"
              :state="validarCampo('data_infracao_inicio')"
              autocomplete="off"
              @keydown.native="keydownPesquisa"
            ></b-input>
            <span class="mt-1 ml-1 mr-1">e</span>
            <b-input
              type="date"
              max="3000-12-31"
              v-model="$v.filtro.data_infracao_fim.$model"
              :state="validarCampo('data_infracao_fim')"
              autocomplete="off"
              @keydown.native="keydownPesquisa"
            ></b-input>
          </b-input-group>
          <span style="font-size: small" class="text-danger" v-if="dataInvalida"
            >Período restrito a 30 dias.</span
          >
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="pb-3">
      <b-col>
        <p class="mb-2">
          <b-icon v-if="!exibirIcone" icon="plus"></b-icon>
          <b-icon v-if="exibirIcone" icon="dash"></b-icon>
          <b-link
            @click="exibir"
            v-b-toggle.busca-avancada
            size="sm"
            class="text-primary"
            variant="outline-white"
            >Busca Avançada</b-link
          >
        </p>
      </b-col>
    </b-row>
    <b-collapse v-model="visible" id="busca-avancada">
      <b-row>
        <b-col cols="md-6 12">
          <b-form-group
            label="Placa"
            label-size="sm"
            invalid-feedback="Informe a placa"
          >
            <b-form-input
              id="placa"
              size="sm"
              v-model="filtro.placa"
              v-mask="'AAA#X##'"
              @blur="blurPlaca"
              class="uppercase"
              v-b-tooltip.bottom
              title="Placa do Veículo (7 dígitos)"
              autocomplete="off"
              @keydown.native="keydownPesquisa"
              @update="verificaCamposBuscaAvancada()"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="md-6 12">
          <b-form-group
            label="RENAVAM"
            label-size="sm"
            invalid-feedback="Informe o código RENAVAM"
          >
            <b-form-input
              id="renavam"
              size="sm"
              v-model="filtro.renavam"
              v-mask="'###########'"
              v-b-tooltip.bottom
              title="Código Renavam do Veículo ( 11 dígitos)"
              autocomplete="off"
              @keydown.native="keydownPesquisa"
              @update="verificaCamposBuscaAvancada()"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="md-6 12">
          <b-form-group label="Número AIT" label-size="sm">
            <b-form-input
              id="numeroAIT"
              size="sm"
              type="text"
              maxlength="10"
              v-mask="numeroAITmask"
              v-model="filtro.numero_ait"
              v-b-tooltip.bottom
              title="Auto de Infração de Trânsito"
              autocomplete="off"
              @keydown.native="keydownPesquisa"
              @update="verificaCamposBuscaAvancada()"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="md-6 12">
          <b-form-group label="Número Processamento" label-size="sm">
            <b-form-input
              id="numeroProcessamento"
              size="sm"
              v-mask="'#########'"
              v-model="filtro.numero_processamento"
              v-b-tooltip.bottom
              title="Número de identificação da multa pelo DETRAN (9 dígitos)"
              autocomplete="off"
              @keydown.native="keydownPesquisa"
              @update="verificaCamposBuscaAvancada()"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="md-6 12">
          <b-form-group label="Número Notificação" label-size="sm">
            <b-form-input
              id="numeroNotificacao"
              size="sm"
              type="number"
              v-model="filtro.numero_notificacao"
              v-b-tooltip.bottom
              title="Notificação de Autuação ou Notificação de Penalidade ou Notificação de Advertência enviadada pelos Correios ou via SNE(Carteira Digital)"
              autocomplete="off"
              @keydown.native="keydownPesquisa"
              @update="verificaCamposBuscaAvancada()"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="md-6 12">
          <b-form-group label="Código Lançamento" label-size="sm">
            <b-form-input
              id="codigoLancamento"
              size="sm"
              v-mask="'##############'"
              v-model="filtro.codigo_lancamento"
              v-b-tooltip.bottom
              title="Número de identificação da multa pela Secretaria Municipal de Fazenda da PBH"
              autocomplete="off"
              @keydown.native="keydownPesquisa"
              @update="verificaCamposBuscaAvancada()"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-collapse>
    <b-row class="mt-2 mb-3">
      <b-col>
        <b-button
          pill
          type="submit"
          class="float-right"
          variant="primary"
          @click="pesquisar"
        >
          <font-awesome-icon :icon="['fa', 'search']" /> Pesquisar
        </b-button>
        <b-button
          pill
          class="mr-1 float-right"
          variant="outline-secondary"
          @click="limpar"
          type="submit"
        >
          <font-awesome-icon :icon="['fa', 'eraser']" /> Limpar
        </b-button>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col>
        <p class="text-secondary" style="font-size: small">
          <em>
            - Permitido pesquisar apenas multas cujo proprietário do veículo
            seja do CPF do usuário logado no GOV.br e/ou CNPJ vinculado ao
            usuário logado no GOV.br.
            <br />

            - Guia de Pagamento: nesse portal, só é possível emitir guia para
            multa de trânsito que não esteja inscrita em Dívida Ativa. Se sua
            multa está inscrita em Dívida Ativa, emita sua guia conforme
            orientações do serviço:
            <b-link
              target="_blank"
              class="text-primary"
              href="https://servicos.pbh.gov.br/servicos/i/5fa3f72d0ceeee0a7e69ad9a/5dc8470253fd6b5bbd99185f/servicos+guias-multa-de-transito-inscritas-em-divida-ativa"
              >Guias - Multa de Trânsito - Inscritas em Dívida Ativa</b-link
            >
  
          </em>
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FiltroMulta from "@/models/FiltroMulta.js";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import { helperMascaras } from "@/helpers/mascaras.js";

export default {
  name: "FiltroMultaCpfCnpjComponent",

  data() {
    return {
      filtro: new FiltroMulta({
        data_infracao_fim: moment().format("YYYY-MM-DD"),
        data_infracao_inicio: moment()
          .subtract(1, "months")
          .format("YYYY-MM-DD"),
      }),
      dataInvalida: false,
      listaCpfCnpj: [],
      exibirIcone: false,
      visible: false,
      buscaAvancada: false,
      numeroAITmask: {
        mask: 'CCCCCCCCCC',
        tokens: { 
          C:  {
            pattern: /[0-9a-zA-Z]/,
            transform: function(v) {
                return v.toLocaleUpperCase();
            }
          } 
        }
      },
    };
  },
  props: {
    filtroDefault: {
      Type: Object,
      default: null,
    },
  },
  validations: {
    filtro: {
      data_infracao_inicio: {
        required: function (val) {
          if (!this.buscaAvancada) {
            if (val) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        },
      },
      data_infracao_fim: {
        required: function (val) {
          if (!this.buscaAvancada) {
            if (val) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        },
      },
      cpf_cnpj_proprietario: { required },
    },
  },

  methods: {
    keydownPesquisa(event) {
      if (event.which === 13) {
        // 13 = Tecla Enter
        this.pesquisar();
      }
    },

    exibir() {
      if (this.exibirIcone) {
        this.visible = true;
        this.exibirIcone = false;
      } else {
        this.visible = false;
        this.exibirIcone = true;
      }
    },

    validarCampo(name) {
      const { $dirty, $error } = this.$v.filtro[name];
      if (!$dirty && $error) {
        return null;
      } else if ($dirty && $error) {
        return false;
      }
    },

    limpar() {
      this.filtro = new FiltroMulta({
        data_infracao_fim: moment().format("YYYY-MM-DD"),
        data_infracao_inicio: moment()
          .subtract(1, "months")
          .format("YYYY-MM-DD"),
      });
      this.$v.filtro.$reset();
      this.$emit("limpar");
    },

    verificarData() {
      if (!this.buscaAvancada) {
        var dataInicio = this.filtro.data_infracao_inicio
          .replaceAll("-", "")
          .toString();
        dataInicio = moment(dataInicio, "YYYYMMDD");
        var dataFim = this.filtro.data_infracao_fim
          .replaceAll("-", "")
          .toString();
        dataFim = moment(dataFim, "YYYYMMDD");
        var diferenca = dataFim.diff(dataInicio, "days");
        if (diferenca <= 31) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },

    pesquisar() {
      this.$v.filtro.$touch();
      if (!this.$v.filtro.$invalid) {
        if (!this.verificarData()) {
          this.dataInvalida = true;
        } else {
          this.dataInvalida = false;
          this.filtro.componente = "cpfCnpj";
          this.$emit("pesquisar", this.filtro, this.buscaAvancada);
        }
      }
    },
    preencherFiltroAnterior(filtroAnterior) {
      this.filtro = new FiltroMulta(filtroAnterior);
      this.$emit("pesquisar", this.filtro);
    },

    limparRecaptcha() {
      this.$refs.recaptchaRef.reloadRecaptcha();
    },

    blurPlaca() {
      if (this.filtro.placa) {
        this.filtro.placa = this.filtro.placa.toUpperCase();
      }
    },

    setFiltroDefault() {
      if (this.filtroDefault && Object.keys(this.filtroDefault).length > 0) {
        this.filtro = JSON.parse(JSON.stringify(this.filtroDefault));
        if (
          this.filtro.numero_ait ||
          this.filtro.numero_processamento ||
          this.filtro.numero_notificacao ||
          this.filtro.codigo_lancamento ||
          this.filtro.placa ||
          this.filtro.renavam
        ) {
          this.visible = true;
        }
      }
    },

    cpfCnpf() {
      var keys = Object.keys(this.$store.getters.userInfo.attributes);
      const result = keys.filter(
        (element) => element.substring(10, 0) == "govbr_cnpj"
      );
      this.listaCpfCnpj = [];
      this.listaCpfCnpj.push(
        helperMascaras.cnpjCpf(this.$store.getters.userInfo.preferred_username)
      );
      if (result.length > 0) {
        result.forEach((element) => {
          this.listaCpfCnpj.push(
            helperMascaras.cnpjCpf(element.substring(25, 11))
          );
        });
      }
      this.filtro.cpf_cnpj_proprietario =
        this.listaCpfCnpj.length == 1 ? this.listaCpfCnpj[0] : null;
    },

    verificaCamposBuscaAvancada() {
      if (
        this.filtro.placa ||
        this.filtro.renavam ||
        this.filtro.numero_ait ||
        this.filtro.numero_processamento ||
        this.filtro.numero_notificacao ||
        this.filtro.codigo_lancamento
      ) {
        this.filtro.data_infracao_inicio = null;
        this.filtro.data_infracao_fim = null;
        this.buscaAvancada = true;
      } else {
        (this.filtro.data_infracao_fim = moment().format("YYYY-MM-DD")),
          (this.filtro.data_infracao_inicio = moment()
            .subtract(1, "months")
            .format("YYYY-MM-DD"));
        this.buscaAvancada = false;
      }
    },
  },

  created() {
    this.setFiltroDefault();
    this.cpfCnpf();
  },

  mounted() {},
};
</script>

<style>
</style>